var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.766,
    height: 29.155,
    viewBox: "0 0 66.766 29.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    transform: "translate(-775.405 -115.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M781.358,117.43a3.007,3.007,0,1,1-2.36-2.36A3.009,3.009,0,0,1,781.358,117.43Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M796.6,118.019a3,3,0,1,1-3-3A3,3,0,0,1,796.6,118.019Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M811.793,118.019a3,3,0,1,1-3.005-3A3,3,0,0,1,811.793,118.019Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M826.982,118.019a3,3,0,1,1-3.005-3A3,3,0,0,1,826.982,118.019Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M842.115,117.43a3.007,3.007,0,1,1-2.361-2.36A3.009,3.009,0,0,1,842.115,117.43Z",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M781.414,129.591a3,3,0,1,1-3-3A3,3,0,0,1,781.414,129.591Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M796.6,129.591a3,3,0,1,1-3-3A3,3,0,0,1,796.6,129.591Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M811.793,129.591a3,3,0,1,1-3.005-3A3.005,3.005,0,0,1,811.793,129.591Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M826.982,129.591a3,3,0,1,1-3.005-3A3.005,3.005,0,0,1,826.982,129.591Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M842.171,129.591a3,3,0,1,1-3.005-3A3,3,0,0,1,842.171,129.591Z",
    fill: "#6c5b7b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M781.359,140.576A3.007,3.007,0,1,1,779,138.215,3.01,3.01,0,0,1,781.359,140.576Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M796.6,141.164a3,3,0,1,1-3-3.005A3,3,0,0,1,796.6,141.164Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M811.793,141.164a3,3,0,1,1-3.005-3.005A3,3,0,0,1,811.793,141.164Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M826.982,141.164a3,3,0,1,1-3.005-3.005A3,3,0,0,1,826.982,141.164Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M842.115,140.576a3.007,3.007,0,1,1-2.361-2.361A3.009,3.009,0,0,1,842.115,140.576Z",
    fill: "#6c5b7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.e0020600db408bac5c338fb3296621f4.svg";
export { ForwardRef as ReactComponent };